
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Products } from "@components/products";
import { NextSeo } from "@components/seo";
import { PVC } from "@consts/ppvc";
import type { IProduct } from "@type/products";
import { getAllPvcByParent } from "@utils/get-products";
import type { GetStaticProps, NextPage } from "next/types";
import { Breadcrumb } from "../../../components/breadcrumb";
interface IProductPage {
    products: IProduct[];
}
const PvcAccesoriesPage: NextPage<IProductPage> = ({ products }) => (<>
    <NextSeo languageAlternates={[
        { href: "https://knsokna.pl/pvc/accessories", hrefLang: "x-default" },
        { href: "https://knswindows.com/pvc/accessories", hrefLang: "en" },
        { href: "https://knsokna.pl/pvc/accessories", hrefLang: "pl" },
        { href: "https://knsfenster.de/pvc/accessories", hrefLang: "de" },
        { href: "https://kns-okna.eu/pvc/accessories", hrefLang: "cs" },
        { href: "https://knsfinestre.it/pvc/accessories", hrefLang: "it" },
        { href: "https://knsfenetres.fr/pvc/accessories", hrefLang: "fr" },
        { href: "https://knsokna.eu/pvc/accessories", hrefLang: "hu" },
    ]}/>
    <div className="bg-white">
      <div className="mx-auto max-w-7xl px-4 py-2 text-center sm:px-6 lg:px-8">
        <Breadcrumb />
        <Products products={products} showId/>
      </div>
    </div>
  </>);
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale ?? "pl";
    const LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    const { products } = await getAllPvcByParent(PVC.ACCESORIES[LOCALE as keyof typeof PVC.ACCESORIES], LOCALE);
    return {
        props: {
            products,
        },
    };
};
export default PvcAccesoriesPage;

    async function __Next_Translate__getStaticProps__1a19cd2bf99__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/pvc/accessories/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2bf99__ as getStaticProps }
  